/* amuee-pdp-blocks.js — behaviour for the Custom Liquid blocks in
   templates/product.json (info tabs, accordion). Loaded deferred from
   layout/theme.liquid on product templates; previously inline <script>. */

/* ---- info tabs (product.json block custom_liquid_infotabs) ---- */
(function () {
  function initTabs(root) {
    if (root.dataset.itabsBound) return;
    root.dataset.itabsBound = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-itabs-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-itabs-panel]'));

    function activate(idx, focus) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
      });
      panels.forEach(function (p, i) { p.hidden = i !== idx; });
      if (focus) tabs[idx].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, idx = null;
        if (e.key === 'ArrowRight') idx = (i + 1) % n;
        else if (e.key === 'ArrowLeft') idx = (i - 1 + n) % n;
        else if (e.key === 'Home') idx = 0;
        else if (e.key === 'End') idx = n - 1;
        if (idx !== null) { e.preventDefault(); activate(idx, true); }
      });
    });

    // Default: first tab active, its panel visible.
    activate(0, false);

    // See Benefits expander (lives inside the Details panel).
    var exp = root.querySelector('[data-itabs-expander]');
    if (exp) {
      var trig = exp.querySelector('[data-itabs-expander-trigger]');
      trig.addEventListener('click', function () {
        var open = exp.classList.toggle('is-open');
        trig.setAttribute('aria-expanded', String(open));
      });
    }
  }

  function initAll() { document.querySelectorAll('.amuee-itabs').forEach(initTabs); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* ---- accordion (product.json block custom_liquid_7bYLir) ---- */
document.querySelectorAll('.amuee-accordion__trigger').forEach(function(btn) {
    if (btn.dataset.amueeBound) return;
    btn.dataset.amueeBound = 'true';
    btn.addEventListener('click', function() {
      var item = btn.closest('.amuee-accordion__item');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

/* ---- Deferred hero slides (see snippets/product-thumbnail.liquid) ----
   Slides 2+ ship with data-src/data-srcset instead of src/srcset. Give them
   back on the first sign the visitor is going to look at them, or once the
   page has been idle for a while. */
(function () {
  var done = false;
  function restore() {
    if (done) return;
    done = true;
    document.querySelectorAll('img[data-amuee-deferred]').forEach(function (img) {
      if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
      if (img.dataset.src) img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-amuee-deferred');
    });
  }
  function init() {
    var galleries = document.querySelectorAll('media-gallery');
    if (!galleries.length) return;
    galleries.forEach(function (gal) {
      ['touchstart', 'pointerdown', 'wheel', 'keydown', 'click'].forEach(function (ev) {
        gal.addEventListener(ev, restore, { capture: true, passive: true });
      });
      gal.querySelectorAll('.product__media-list, .thumbnail-list').forEach(function (list) {
        list.addEventListener('scroll', restore, { passive: true });
      });
    });
    /* Any page scroll means the visitor is engaged: load them shortly after. */
    window.addEventListener('scroll', function onScroll() {
      window.removeEventListener('scroll', onScroll);
      setTimeout(restore, 1500);
    }, { passive: true });
    /* Last resort so a visitor who sits still still gets a ready gallery. */
    window.addEventListener('load', function () {
      setTimeout(function () {
        if (window.requestIdleCallback) requestIdleCallback(restore, { timeout: 4000 }); else restore();
      }, 8000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
